import { ProgressSpinner } from 'primereact/progressspinner'
import styled from 'styled-components'

export default function Loader({ src }: { src: string }) {
  return (
    <LoaderWrapper>
      <ProgressSpinner />
      <LoaderImage src={src} alt="loader" />
    </LoaderWrapper>
  )
}

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;

  .p-progress-spinner {
    width: 120px;
  }
`

const LoaderImage = styled.img`
  position: absolute;
  width: 50px;
`
